import NextImage from "../NextImage";
import Translations from "@translate/components/QuickInsights/components";
import { I18nUtil } from "@utils/i18n";

const I18n = I18nUtil.createScoped(Translations);

// 空状态组件
export const EmptyState = () => (
  <div className="flex flex-col justify-center items-center w-full">
    <NextImage
      src="/assets/images/agent-empty-light.webp"
      alt="empty"
      width={120}
      height={120}
    />
    <span className="body_medium_l text-content_secondary mt-2 mb-1">
      {I18n.t("No Data Yet")}
    </span>
    <span className="body_m text-content_quaternary">
      {I18n.t("No data yet, but exciting updates are on the horizon!")}
    </span>
  </div>
);

// 加载状态组件
export const LoadingState = ({
  count = 2,
  className,
}: {
  count?: number;
  className?: string;
}) => {
  const baseClassName = className || "grid gap-3 grid-cols-2";
  return (
    <div className={baseClassName}>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="flex gap-2 bg-background_white_overlay5 rounded-xl py-3 px-4 items-center"
        >
          <div className="h-8 w-8 rounded-full bg-background_white_overlay10 animate-pulse" />
          <div className="flex flex-col gap-2 flex-1">
            <div className="h-4 w-[73px] rounded-1 bg-background_white_overlay10 animate-pulse" />
            <div className="h-3 w-full rounded-1 bg-background_white_overlay10 animate-pulse" />
          </div>
        </div>
      ))}
    </div>
  );
};

// 无搜索结果提示
export const NoSearchResults = () => (
  <div className="flex flex-col justify-center items-center w-full py-12">
    <div className="w-20 h-20 mb-4 flex items-center justify-center">
      <NextImage
        src="/assets/images/searchEmpty.webp"
        alt="No results"
        width={80}
        height={80}
      />
    </div>
    <span className="body_l text-content_quaternary">
      {I18n.t("No search results yet")}
    </span>
  </div>
);
